module.exports = __webpack_public_path__ + "static/media/honey-dryfruit.491cb4bf.jpg";